import React, { useState } from 'react'
import Banner from './h.png'
import logo from './logo.png'
// import Banner from './hez.12cb5928b16833d0fde1.png'
import {FcDepartment} from 'react-icons/fc'
import {LuChurch} from 'react-icons/lu'
import {FaLocationArrow, FaPeopleArrows, FaPiggyBank} from 'react-icons/fa'
import {GrMapLocation} from 'react-icons/gr'
import {TiArrowBack, TiArrowUpThick, TiGroup} from 'react-icons/ti'
import {GrGroup} from 'react-icons/gr'
// import { usePaystackPayment } from "react-paystack";
import firebase from "../firebaseConfig";
import validator from 'validator';
import { useEffect } from "react";
import { BiArrowBack, BiCheckDouble, BiSolidBusiness, BiSolidGroup } from 'react-icons/bi'
import { AiFillCloseCircle } from 'react-icons/ai'
import { useSeerbitPayment } from 'seerbit-reactjs'
import { useParams } from 'react-router-dom'

const PaystackForm = ({ email, onSuccess, onClose, handleOrderAttempts }) => {
  const { id } = useParams();
    const [Cat, setCat] = useState([]);
    const [data, setData] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [fellowships, setFellowship] = useState([]);
    const [events, setEvents] = useState([]);
    const [states, setStates] = useState([]);
    const [groups, setGroups] = useState([]);
    const [priests, setPriests] = useState([]);
    const [tithes, setTithes] = useState([]);
    const [Area, setArea] = useState([]);
    const [Zone, setZone] = useState([]);
    const [Bethel, setBethel] = useState([]);
    const [selectedPurpose, setSelectedPurpose] = useState('tithe');
    const [amount, setAmount] = useState(0);
  
    const handlePurposeChange = (e) => {
      setSelectedPurpose(e.target.value);
      setUserData({ ...userData, purpose: selectedPurpose });
    };

    const handleAmountChange = (e) => {
      setAmount(parseFloat(e.target.value + 50));
    };

    // const taxAmount = 50;

  
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    prayer: "",
    Bethel: "", 
    amount: id,
    paymentDescription: "",
    purpose: "VETH INTERIORS/Library",
    id: "bWlNwAOMpSWgj3Z97t1W",
    category: "Department",
    month: "",
  });
  const calculatePaymentAmount = () => {
    return parseFloat(userData.amount) * 100; // Convert to kobo
  };
  
  const config = {
    reference: new Date().getTime().toString(),
    email: userData.email,
    amount: userData.amount * 100, // Paystack accepts amount in kobo, so multiply by 100
    // publicKey: "pk_live_1c64818f3b0f7b300fb0ec33ca60c5a9f598ac09", 
    publicKey: "pk_live_21f9417f1a5dcc46c74738b3d9be49c56267f92e", // Replace with your Paystack public key
    // publicKey: "pk_test_a6299b3c7d13aff9b8fe0ffa7a5dc16a6442d86f", // Replace with your Paystack public key
  };


  const options = {
    public_key: "SBPUBK_JOTLK6SWKTJYVY3HEZMOVAOPURTQZIM2",
    // bcsofficialsecret_key: "SBSECK_A0UFCXWNWGSIGKRLZN6TWNOXVVAU6EM4ZEZIEKFC",
    // public_key: "SBPUBK_WRTM2ICVS2JG8VRWNSBZR43XNPXZ8PEF",
    // // public_key: "SBTESTPUBK_MUgNegcGcCwQTRKic9dBLOpnml2wlH7h",
    amount: id,
    tranref: new Date().getTime(),
    currency: "NGN",
    email: userData.email,
    full_name: userData.name,
    mobile_no: userData.phoneNumber,
    description: "BCS PAYMENT PORTAL",
    tokenize: false,
    planId: "",
    pocketId: "",
    vendorId: "",
    customization: {
      theme: {
        border_color: "#000000",
        background_color: "#004C64",
        button_color: "#0084A0",
      },
      payment_method: ["card", "account", "transfer", "wallet", "ussd"],
      display_fee: true, // true
      display_type: "embed", //inline
      logo: "https://pay.ooobcs.org/static/media/favicon.f4ce3832bbe056ed6df0.jpg",
    },
  };

  const close = (close) => {
  //  console.log(close);
   onClose();

 };

 const callback = (response, closeCheckout) => {
   console.log('Amos Said', response.message);
   if (response.message === 'Successful'){
     onSuccess(response, userData);

   }
   
   
   setTimeout(() => closeCheckout(), 2000);
 };
 
 const initializePayment2 = useSeerbitPayment(options, callback, close);



  const onSuccessCallback = (response) => {
    onSuccess(response, userData);
  };

  const onCloseCallback = (response) => {
    onClose();
    // handleOrderAttempts(response, userData );
  };

  const onOrderAttempt = (response) => {
    handleOrderAttempts(response, userData );
  };


  // const initializePayment = usePaystackPayment(config);
  
  const [errorFields, setErrorFields] = useState({});
  const [error, setError] = useState('');
  const [Show, setShow] = useState(true);
  const [nav, setNav] = useState(true)
  const [navAcct, setNavAcct] = useState(true)
  const [anime, setAnime] = useState(false)



  const handlePayment2 = () => { 

    onOrderAttempt()
  
    const requiredFields = ['name', 'email', 'phoneNumber', 'purpose'];
    const errorFieldsCopy = { ...errorFields };
    let hasError = false;
  
    requiredFields.forEach((field) => {
      if (!userData[field]) {
        errorFieldsCopy[field] = true;
        hasError = true;
      } else {
        errorFieldsCopy[field] = false;
      }
    });
  
    if (!validator.isEmail(userData.email)) {
      errorFieldsCopy.email = true;
      hasError = true;
    } else {
      errorFieldsCopy.email = false;
    }

    if (userData.purpose === 'direct tithe' || userData.purpose === 'personal tithe') {
      const additionalRequiredFields = ['location', 'Bethel', 'month', 'prayer'];
  
      additionalRequiredFields.forEach((field) => {
        if (!userData[field]) {
          errorFieldsCopy[field] = true;
          hasError = true;
        } else {
          errorFieldsCopy[field] = false;
        }
      });
  
      if (!userData.prayer) {
        errorFieldsCopy.prayer = true;
        hasError = true;
      } else {
        errorFieldsCopy.prayer = false;
      }
    }
  
    setErrorFields(errorFieldsCopy);
  
    if (hasError) {
      setError('Please fill in all required fields before making a payment.')
      return;
    } else {
      initializePayment2();
    }
    // initializePayment2(options, callback, close);
  };
  const handlePayment = () => { 

    onOrderAttempt()
  
    const requiredFields = ['name', 'email', 'phoneNumber', 'amount',];
    const errorFieldsCopy = { ...errorFields };
    let hasError = false;
  
    requiredFields.forEach((field) => {
      if (!userData[field]) {
        errorFieldsCopy[field] = true;
        hasError = true;
      } else {
        errorFieldsCopy[field] = false;
      }
    });
  
    if (!validator.isEmail(userData.email)) {
      errorFieldsCopy.email = true;
      hasError = true;
    } else {
      errorFieldsCopy.email = false;
    }

    if (userData.purpose === 'direct tithe' || userData.purpose === 'personal tithe') {
      const additionalRequiredFields = ['location', 'Bethel', 'month', 'prayer'];
  
      additionalRequiredFields.forEach((field) => {
        if (!userData[field]) {
          errorFieldsCopy[field] = true;
          hasError = true;
        } else {
          errorFieldsCopy[field] = false;
        }
      });
  
      if (!userData.prayer) {
        errorFieldsCopy.prayer = true;
        hasError = true;
      } else {
        errorFieldsCopy.prayer = false;
      }
    }
  
    setErrorFields(errorFieldsCopy);
  
    if (hasError) {
      setError('Please fill in all required fields before making a payment.')
      return;
    } else {
      // initializePayment(onSuccessCallback, onCloseCallback);
    }
    // initializePayment(onSuccessCallback, onCloseCallback);
  };

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };


    const [searchQuery, setSearchQuery] = useState('');
  const filteredItems = Cat?.filter(item =>
    item.department_name?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  useEffect(() => {
    async function getResponse() {
      // Initialize Firebase

      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection.get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

        // Sort filtered departments data
        const sortedDepartments = Products.sort((a, b) =>
        a.department_name?.localeCompare(b.department_name)
      );

      setCat(sortedDepartments);
    }

    getResponse();
  }, []);


  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "Department")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

       // Sort filtered departments data
       const sortedDepartments = Products.sort((a, b) =>
       a.department_name?.localeCompare(b.department_name)
     );

      setDepartments(sortedDepartments);
    }

    getResponse();
  }, []);


  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "Fellowship")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

         // Sort filtered departments data
         const sortedDepartments = Products.sort((a, b) =>
         a.department_name?.localeCompare(b.department_name)
         );

         setFellowship(sortedDepartments)

    }

    getResponse();
  }, []);

  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "Events")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      // Sort filtered departments data
      const sortedDepartments = Products.sort((a, b) =>
      a.department_name?.localeCompare(b.department_name)
      );
      
      setEvents(sortedDepartments)
    }

    getResponse();
  }, []);

  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "States")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      // Sort filtered departments data
      const sortedDepartments = Products.sort((a, b) =>
      a.department_name?.localeCompare(b.department_name)
      );
      
      setStates(sortedDepartments)
    }

    getResponse();
  }, []);

  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "Groups")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      // Sort filtered departments data
      const sortedDepartments = Products.sort((a, b) =>
      a.department_name?.localeCompare(b.department_name)
      );
      
      setGroups(sortedDepartments)
    }

    getResponse();
  }, []);

  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "Priestly Bodies")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      // Sort filtered departments data
      const sortedDepartments = Products.sort((a, b) =>
      a.department_name?.localeCompare(b.department_name)
      );
      
      setPriests(sortedDepartments)
    }

    getResponse();
  }, []);

  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "Tithes")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      // Sort filtered departments data
      const sortedDepartments = Products.sort((a, b) =>
      a.department_name?.localeCompare(b.department_name)
      );
      setTithes(sortedDepartments)
    }

    getResponse();
  }, []);

  
  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "Area")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      // Sort filtered departments data
      const sortedDepartments = Products.sort((a, b) =>
      a.department_name?.localeCompare(b.department_name)
      );
      setArea(sortedDepartments)
    }

    getResponse();
  }, []);
  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "Zone")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      // Sort filtered departments data
      const sortedDepartments = Products.sort((a, b) =>
      a.department_name?.localeCompare(b.department_name)
      );
      setZone(sortedDepartments)
    }

    getResponse();
  }, []);
  useEffect(() => {
    async function getResponse() {
      const db = firebase.firestore();
      const collection = db.collection("BCS");
      const snapshot = await collection
      .where("category", "==", "Bethel")
      .get();
      const Products = [];

      snapshot.forEach((doc) => {
        Products.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      // Sort filtered departments data
      const sortedDepartments = Products.sort((a, b) =>
      a.department_name?.localeCompare(b.department_name)
      );
      setBethel(sortedDepartments)
    }

    getResponse();
  }, []);



  const handleNav = () => {
    setNav(!nav)
};
  const handleNavAcct = () => {
    setNavAcct(!navAcct)
};
const handleAnime = () => {
setAnime(!anime)
}



const [isVisible, setIsVisible] = useState(false);

const listenToScroll = () => {
    let heightToHideFrom = 100;
    const winScroll = document.body.scroll ||
        document.documentElement.scroll;

    if (winScroll > heightToHideFrom) {
        isVisible &&      // to limit setting state only the first time
            setIsVisible(false);
    } else {
        setIsVisible(true);
    }
};

const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
}

useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () =>
        window.removeEventListener("scroll", listenToScroll);
}, [])


// console.log(Show)
  return (
    <div className='lg:p-10 p-1 relative mt-7'>



{
       !navAcct ? 
       
       
      <div
      className="text-black bg-[rgba(255,255,255,0.8)] w-[100%] h-[100%] absolute z-50 items-center justify-center"
      >
        <div 
        onClick={handleNavAcct}
        className='bg-blue-600 font-semibold flex items-center justify-center text-white fixed p-5 rounded-2xl cursor-pointer hover:bg-gray-600 top-32 lg:right-10 right-5'>
          <TiArrowBack />
          <p>&nbsp; Go Back
          </p>
        </div>
        <div 
onClick={scrollToTop}
        className='bg-blue-600 font-semibold flex items-center justify-center text-white fixed p-5 rounded-2xl cursor-pointer hover:bg-gray-600 bottom-10 lg:right-5 right-5'>
          <TiArrowUpThick />
          <p>
          </p>
        </div>

        <input 
        value={searchQuery}
                        onChange={(e) => {
                          if(e) {
                            setSearchQuery(e.target.value)
                            // setShow(false)
                            // setShows(false)
                          }else {
                          }}}
                          onClick={ async () =>{
                            // handleAnime() 
                            // setShow(false)
                          }}
                        className='outline-blue-400 ml-1 mt-4 mb-7 md:mt-0 border-gray-300 p-7 rounded-full h-10 w-[100%] border-[0.6px]'
                     type="search" name="" id="" placeholder='Search Category...' />

        {filteredItems.map((item, index) => (
  
  <div key={index}>
  {/* {
    !Show ? */}

<div
onClick={async () => { 
  // setUserData({...userData, purpose: item.department_name})
  // setSearchQuery(item.department_name)
  // setUserData({...userData, id: item.id, category: item.category, purpose: item.department_name})
  // setShow(true)
  
}}
// onClick={() =>  setUserData({...userData, purpose: item.department_name})}
// name="purpose"
// value={userData.purpose}
// onChange={(e) => setUserData({ ...userData, purpose: e.target.value })}
className={errorFields.name ? 'border-red-400 border-2 bg-gray-200 rounded-md text-start text-bold mb-3 w-[70%] p-2' : 'border-2 bg-gray-200 border-gray-300 rounded-md text-center font-bold mb-3 lg:h-12 h-20 w-[100%] p-2 pb-5'}
>
          <p
          className='z-50 text-gray-800'
          // onClick={handleNav} 
          >
           {item.department_name} - Account Number: {item.account_number} 9 Payment Service Bank
          </p>
</div>

{/* : null
  } */}
  </div>
        ))}
 </div>
: null
}


{
       !nav ? 
       
       
      <div
      className="text-black bg-[rgba(255,255,255,0.8)] w-[100%] h-[100%] absolute z-50 items-center justify-center"
      >
        <div 
        onClick={handleNav}
        className='bg-blue-600 font-semibold flex items-center justify-center text-white fixed p-5 rounded-2xl cursor-pointer hover:bg-gray-600 top-32 lg:right-10 right-5'>
          <TiArrowBack />
          <p>&nbsp; Go Back
          </p>
        </div>
        <div 
onClick={scrollToTop}
        className='bg-blue-600 font-semibold flex items-center justify-center text-white fixed p-5 rounded-2xl cursor-pointer hover:bg-gray-600 bottom-10 lg:right-5 right-5'>
          <TiArrowUpThick />
          <p>
          </p>
        </div>
    {data.map((data, index) => (
        
<div key={index}
onClick={async () => { 
  // setUserData({...userData, purpose: item.department_name})
  setSearchQuery(data.department_name)
  setUserData({...userData, id: data.id, category: data.category, purpose: data.department_name})
  handleNav()
  // handleAnime()
}}
// onClick={() =>  setUserData({...userData, purpose: item.department_name})}
// name="purpose"
// value={userData.purpose}
// onChange={(e) => setUserData({ ...userData, purpose: e.target.value })}
className={errorFields.name ? 'border-red-400 border-2 bg-red-200 cursor-pointer rounded-md text-start text-bold mb-3 w-[70%] p-2' : 'border-2 bg-gray-200 border-gray-300 self-center cursor-pointer rounded-md text-center h-12 font-bold mb-3 w-[100%] p-2'}
>
          <p
          className='z-50 text-gray-800'
          // onClick={handleNav} 
          >
           {data.department_name}
          
          </p>
</div>


))}
 </div>
: null
}

<div className='lg:flex lg:flex-row-reverse gap-20'>
            


            <div
                    className='lg:flex justify-center font-semibold mt-5 items-center '
            >
                <img src={Banner} alt="banner" className='shadow-md lg:w-[50%] rounded-2xl' />
       <div className='text-center mt-0 w-[100%] md:w-[100%] pb-10'>


       <div 
        className='flex justify-center dark:text-white font-semibold mt-5 items-center '
        
        >
          Step
          <p
          className='bg-blue-600 items-center flex shadow-2xl  ml-2 justify-center text-white p-3 rounded-full h-8 w-8 '
          > 
          <b>
            1
            </b>
          </p>
        </div>
       {/* {filteredItems.map((item, index) => (
  
  <>
  {
    !Show ?

<div
onClick={async () => { 
  // setUserData({...userData, purpose: item.department_name})
  setSearchQuery(item.department_name)
  setUserData({...userData, id: item.id, purpose: item.department_name})
  setShow(true)
}}
// onClick={() =>  setUserData({...userData, purpose: item.department_name})}
// name="purpose"
// value={userData.purpose}
// onChange={(e) => setUserData({ ...userData, purpose: e.target.value })}
className={errorFields.name ? 'border-red-400 border-2 bg-gray-200 rounded-md text-start text-bold mb-3 w-[70%] p-2' : 'border-2 bg-gray-200 border-gray-300 rounded-md text-center font-bold mb-3 w-[100%] p-2'}>
          <option
          key={index} >
           {item.department_name}
          </option>
</div>

: null
  }
  </>
        ))} */}
     <input 
        value={"VETH INTERIORS/Library"}
                        onChange={(e) => {
                          if(e) {
                            setSearchQuery(e.target.value)
                            setShow(false)
                          }else {
                          }}}
                          onClick={() => setShow(false)}
                        className='border-[0.7px] bg-gray-100 mt-5 outline-blue-300 border-gray-300 rounded-sm text-center mb-3 w-[70%] p-2'
                     type="search" name="" id="" placeholder='Select Category' />
                <div>
                <label className="text-gray-700 text-center ">Full Name <b className='text-red-600'>*</b></label>
                <br/>
                <input type="text" required
            value={userData.name}
            onChange={(e) => setUserData({ ...userData, name: e.target.value })}
            className={errorFields.name ? 'border-red-400 border-2 bg-gray-200 rounded-md text-center mb-3 w-[70%] p-2' : 'border-[0.7px] outline-blue-300 bg-gray-100 border-gray-300 rounded-md text-start mb-3 w-[70%] p-2'}/>

                </div>
                
                <div>
                <label className="text-gray-600  text-center mt-2">Email Address <b className='text-red-600'>*</b></label>
                <br/>
                <input type="email"
                    name="email"
                    value={userData.email}
                    onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                    className={errorFields.email ? 'border-red-400 border-2 bg-gray-200 rounded-md text-center mb-3 w-[70%] p-2' : 'border-[0.7px] bg-gray-100 outline-blue-300 border-gray-300 rounded-md text-start mb-3 w-[70%] p-2'}/>

                </div>
            
                <div>
                <label className="text-gray-600 mt-2 text-center ">Phone Number <b className='text-red-600'>*</b> </label>
                <br/>
                <input type="text"
                           name="phoneNumber"
                           value={userData.phoneNumber}
                           onChange={(e) => setUserData({ ...userData, phoneNumber: e.target.value })}
                           className={errorFields.name ? 'border-red-400 border-2 bg-gray-200 rounded-md text-center mb-3 w-[70%] p-2' : 'border-[0.7px] bg-gray-100 border-gray-300 outline-blue-300 rounded-md text-start mb-3 w-[70%] p-2'}/>
                </div>
                <div>
                <label className="text-gray-600 mt-2 text-center ">Amount <b className='text-red-600'>*</b></label>
                <br/>
                <input type="number" placeholder='₦ 0.00'
                            required
                            value={id}
                            onChange={ async (e) => { 
                              if(e.target.value < 1){alert("Negative Figure Not Allowed")}
                              else{
                                setUserData({ ...userData, amount: e.target.value })
                              }
                            
                            }}
                            className={errorFields.name ? 'border-red-400 border-2 bg-gray-200 rounded-md text-center mb-3 w-[70%] p-2' : 'border-[0.7px] bg-gray-100 border-gray-300 outline-blue-300 rounded-md text-start mb-3 w-[70%] p-2'}/>
                </div>

    {userData.purpose === 'Direct Tithe'  ?
null :
userData.purpose === 'Personal Tithe' ?
null :
<div>
          <label className="text-gray-600 mt-2 text-center ">Delivery Address & Payment Description <b className='text-red-600'>*</b></label>
          <br/>
          <input type="text"
                    name="paymentDescription"
                    required
                    value={userData.paymentDescription}
                    onChange={(e) => setUserData({ ...userData, paymentDescription: e.target.value })}
                    className={errorFields.name ? 'border-red-400 border-2 bg-gray-200 rounded-md text-center mb-3 w-[70%] p-2' : 'border-[0.7px] outline-blue-300 bg-gray-100 border-gray-300 rounded-md text-start mb-3 w-[70%] p-2'}/>
        </div>
}
{(userData.purpose === "Personal Tithe" || userData.purpose === "Direct Tithe") &&(

         <div>
         <label className="text-gray-600  text-center "> Prayer request </label>
                   <br/>
         <input type="text"
           name="prayer"
           value={userData.prayer}
           onChange={(e) => setUserData({ ...userData, prayer: e.target.value })}
           className={errorFields.name ? 'border-red-400 border-2 bg-gray-200 rounded-md text-center mb-3 w-[70%] p-2' : 'border-2 py-14 bg-gray-200 border-gray-300 rounded-md text-center mb-3 w-[70%] p-2'}/>
       </div> 
)
}

<div 
        className='flex justify-center font-semibold mt-5 dark:text-white mr-2 items-center '
        
        >
        Final  Step
          <p
          className='bg-blue-600 items-center flex shadow-2xl justify-center text-white p-3 ml-2 rounded-full h-8 w-8 '
          > 
          <b>
            2
            </b>
          </p>
        </div>

<div className=" justify-center flex m-5">
        {/* <button
          onClick={handlePayment}
          className="m-2 lg:ml-0 hover:bg-transparent text-center items-center flex font-bold py-5 px-16 drop-shadow-2xl shadow-2xl bg-white text-blue-500 rounded-lg"
          // className="rounded-lg md:w-[20%] w-[30%] mt-5 md:-mt-1 md:m-5 h-14 bg-gray-700"
        >
          <div className="flex items-center justify-center " >
                            <img style={{ width: 45, height: 25, marginRight: 10 }} alt="we"
                             src={logo}/>
            <p className=" mr-2 text-sm">PAY</p>
                                </div>
                   </button> */}
        {/* <br /> */}
        <button
          // onClick={async() => {    
          //   onOrderAttempt()
          //   initializePayment2()
          // }}
          // onClick={initializePayment2}
          onClick={handlePayment2}
          className="m-2 lg:ml-0 hover:bg-transparent text-center items-center flex font-bold py-5 px-16 drop-shadow-2xl shadow-2xl bg-white text-red-600 rounded-lg"
          // className="rounded-lg md:w-[20%] w-[30%] mt-5 md:-mt-1 md:m-5 h-14 bg-gray-700"
        >
          <div className="flex items-center justify-center " >
                            <img style={{ width: 45, height: 25, marginRight: 10 }} alt="we"
                             src={logo}/>
            <p className=" mr-2 text-sm">PAY</p>
                                {/* src='data:image/png;base64,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'/>  */}
                                </div>
                   </button>
        <br />
        <br />
        {/* <button
          className="mt-5 w-[30%] md:w-[20%] text-white font-bold text-2xl  md:mt-0 rounded-lg h-14 bg-gray-700"
        >
          cancel
        </button> */}
      </div> 

        </div>         
            </div>

        </div>
        
    </div>
  )
}

export default PaystackForm